import { render, staticRenderFns } from "./MixCouveturesFromShelf.vue?vue&type=template&id=10d045a6"
import script from "./MixCouveturesFromShelf.vue?vue&type=script&lang=js"
export * from "./MixCouveturesFromShelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports